/**
 * Mixin for components that need to load and display restaurant users.
 * Provides `users` computed (with fullName), `fetchUsers` method, and `loadingUsers` state.
 * Used by: PurchaseOrderDialog, WaybillDialog, WriteOffDialog, ReturnDialog, PurchaseStatusDialog, EntryGroceryDialog
 */
export default {
  data() {
    return {
      loadingUsers: false,
    };
  },
  computed: {
    users() {
      return this.$store.state.restaurantStore.users.map((user) => ({
        ...user,
        fullName: [user.name, user.lastname]
          .map((name) => this.toLatin(name))
          .join(" "),
      }));
    },
  },
  methods: {
    async fetchUsers(refetch = false) {
      try {
        this.loadingUsers = true;
        await this.$store.dispatch("restaurantStore/dispatchUsers", {
          refetch,
        });
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loadingUsers = false;
      }
    },
  },
};
